import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import { Form, Formik } from "formik";
import { FormControl } from "../form-control";
import Input from "../input";
import Button from "../button";
import { Images } from "@assets/images";
import { resetPasswordValidationSchema } from "@app/validations";

interface ResetPasswordModalProps {
  newPassword?: string;
}

const ResetPasswordModal = ({
  portalDialogRef,
}: PortalDialogProps<ResetPasswordModalProps>) => {
  const onSubmit = (values: { newPassword?: string }) => {
    const result: ResetPasswordModalProps = {};

    if (values.newPassword) {
      result.newPassword = values.newPassword;
    }

    portalDialogRef.close(result);
  };

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[423px] py-7 px-6">
        <div className="text-black font-semibold text-xl">Reset Password</div>
        <Formik
          initialValues={{ newPassword: "", confirmNewPassword: "" }}
          validationSchema={resetPasswordValidationSchema}
          onSubmit={onSubmit}
          validateOnChange
          validateOnBlur
        >
          <Form>
            <FormControl name="newPassword">
              <Input
                type="password"
                inputIcon={Images.SecurityIcon.default}
                inputIconClassName="hidden"
                inputClassName="font-[SVN-Gilroy] my-2 font-medium !text-[#272C36] tracking-[0.024px]"
                errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                placeholder="Mật khẩu mới"
              />
            </FormControl>
            <FormControl name="confirmNewPassword">
              <Input
                type="password"
                inputIcon={Images.SecurityIcon.default}
                inputIconClassName="hidden"
                inputClassName="font-[SVN-Gilroy] my-2 font-medium !text-[#272C36] tracking-[0.024px]"
                errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                placeholder="Nhập lại mật khẩu mới"
              />
            </FormControl>
            <p className="mt-4 text-[14px] italic">
              Nếu bạn không nhập mật khẩu mới, chúng tôi sẽ gửi một mật khẩu bất
              kỳ đến email của user
            </p>
            <div className="mt-8 flex justify-center gap-4">
              <Button
                type="button"
                size="xs"
                label="Hủy"
                theme="secondary"
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
                onClick={portalDialogRef.close}
              />
              <Button
                type="submit"
                size="xs"
                label="Cập nhật"
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
              />
            </div>
          </Form>
        </Formik>
      </div>
    </Modal>
  );
};

export default ResetPasswordModal;
